// extracted by mini-css-extract-plugin
var _1 = "SummaryTableStyle-module__item___QlN8Z";
var _2 = "SummaryTableStyle-module__item-label___Icqzv";
var _3 = "SummaryTableStyle-module__item-value___owjAC";
var _4 = "SummaryTableStyle-module__item-label___Icqzv";
var _5 = "SummaryTableStyle-module__item-value___owjAC";
var _6 = "SummaryTableStyle-module__row___yx6F9";
var _7 = "SummaryTableStyle-module__table___X34by";
export { _1 as "item", _2 as "item-label", _3 as "item-value", _4 as "itemLabel", _5 as "itemValue", _6 as "row", _7 as "table" }
